export type ComparativeDirection = 'up' | 'down' | 'stable';
export type ComparativeNormalization = 'daily' | 'hourly';

export class ComparativeMetric {
    current!: number;
    previous!: number;
    variationPercent!: number;
    direction!: ComparativeDirection;
    isImprovement!: boolean;

    static fromJson(json: Record<string, any>): ComparativeMetric {
        return new ComparativeMetric({
            current: json['current'] as number,
            previous: json['previous'] as number,
            variationPercent: json['variationPercent'] as number,
            direction: json['direction'] as ComparativeDirection,
            isImprovement: json['isImprovement'] as boolean,
        });
    }

    constructor({
        current,
        previous,
        variationPercent,
        direction,
        isImprovement
    }: {
        current: number;
        previous: number;
        variationPercent: number;
        direction: ComparativeDirection;
        isImprovement: boolean;
    }) {
        Object.assign(this, {current, previous, variationPercent, direction, isImprovement});
    }
}

export class ComparativePeriodInfo {
    start!: string;
    end!: string;
    durationHours!: number;
    durationDays!: number;

    static fromJson(json: Record<string, any>): ComparativePeriodInfo {
        return new ComparativePeriodInfo({
            start: json['start'] as string,
            end: json['end'] as string,
            durationHours: json['durationHours'] as number,
            durationDays: json['durationDays'] as number,
        });
    }

    constructor({
        start,
        end,
        durationHours,
        durationDays
    }: {
        start: string;
        end: string;
        durationHours: number;
        durationDays: number;
    }) {
        Object.assign(this, {start, end, durationHours, durationDays});
    }
}

export class ComparativeRankItem {
    id?: string;
    name!: string;
    current!: number;
    previous!: number;
    variationPercent!: number;
    direction!: ComparativeDirection;
    isImprovement!: boolean;

    static fromJson(json: Record<string, any>): ComparativeRankItem {
        return new ComparativeRankItem({
            id: json['id'] as string | undefined,
            name: json['name'] as string,
            current: json['current'] as number,
            previous: json['previous'] as number,
            variationPercent: json['variationPercent'] as number,
            direction: json['direction'] as ComparativeDirection,
            isImprovement: json['isImprovement'] as boolean,
        });
    }

    constructor({
        id,
        name,
        current,
        previous,
        variationPercent,
        direction,
        isImprovement
    }: {
        id?: string;
        name: string;
        current: number;
        previous: number;
        variationPercent: number;
        direction: ComparativeDirection;
        isImprovement: boolean;
    }) {
        Object.assign(this, {id, name, current, previous, variationPercent, direction, isImprovement});
    }
}
